import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "plate-header" }
const _hoisted_2 = { class: "plate-title" }
const _hoisted_3 = { class: "plate-subtitle" }
const _hoisted_4 = { style: {"text-align":"left","display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "图片/视频大小需小于20MB。", -1)
const _hoisted_6 = { style: {"text-align":"right"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" (`ヮ´ ) ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 回复 ")
const _hoisted_9 = { style: {"font-size":"10px","color":"var(--theme-secondary)"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--theme-secondary)"} }, " 选择你的颜文字酱！ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_film = _resolveComponent("film")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_PostNodeHead = _resolveComponent("PostNodeHead")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PostNode = _resolveComponent("PostNode")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.plateData.name), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.plateData.value), 1),
      (_ctx.plateId != 0)
        ? (_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            id: "plate-input",
            modelValue: _ctx.postInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postInput.value) = $event)),
            autosize: { minRows: 2, maxRows: 4 },
            type: "textarea",
            placeholder: "来说点什么吧",
            style: {"padding-bottom":"5px"},
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setInputBuff(_ctx.postInput.value)))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.plateId != 0)
        ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 16 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_upload, {
                      class: "upload-demo",
                      action: "https://forum-api.islander.top/img/upload",
                      headers: { Authorization: _ctx.authToken },
                      accept: "image/*,video/*",
                      multiple: "",
                      "on-success": 
              (response, file) => {
                _ctx.getUploadInfo(response, file);
              }
            ,
                      "on-remove": _ctx.delUploadInfo,
                      limit: 5,
                      ref: "upload"
                    }, {
                      tip: _withCtx(() => [
                        _hoisted_5
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          color: "var(--theme-primary)"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_film)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["headers", "on-success", "on-remove"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          color: "var(--theme-primary)",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drawInfo.status = true))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.postForumPost(
                  _ctx.plateId,
                  _ctx.postInput.value,
                  _ctx.postInput.title,
                  _ctx.postInput.mediaUrl
                )
              )),
                          color: "var(--theme-primary)",
                          loading: _ctx.postingStatus
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.res.list, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: "plate-class"
        }, [
          _createVNode(_component_PostNode, {
            postNode: item,
            userId: _ctx.userId
          }, {
            "post-head": _withCtx(() => [
              _createVNode(_component_router_link, {
                to: '/post/' + item.id + '/page/1'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PostNodeHead, { postNode: item }, _createSlots({ _: 2 }, [
                    (_ctx.plateId == 0)
                      ? {
                          name: "post-head-tag",
                          fn: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getPlateData(item.plateId)?.name || '未知板块'), 1)
                          ])
                        }
                      : undefined
                  ]), 1032, ["postNode"])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            "reply-count": _withCtx(() => [
              _createElementVNode("div", _hoisted_9, " 还有" + _toDisplayString(item.replyCount) + "条串 ", 1)
            ]),
            _: 2
          }, 1032, ["postNode", "userId"])
        ])), [
          [_directive_loading, _ctx.loadingStatus]
        ])
      }), 128))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        "page-size": _ctx.pageRes.size,
        "page-count": Math.ceil(_ctx.res.count / _ctx.pageRes.size),
        "hide-on-single-page": Math.ceil(_ctx.res.count / _ctx.pageRes.size) == 1,
        "current-page": _ctx.pageRes.page,
        "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageRes.page) = $event))
      }, null, 8, ["page-size", "page-count", "hide-on-single-page", "current-page"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawInfo.status,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.drawInfo.status) = $event)),
      direction: _ctx.drawInfo.direction,
      size: _ctx.drawInfo.size
    }, {
      title: _withCtx(() => [
        _hoisted_10
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"text-align":"center"} }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emoji, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                span: 4,
                onClick: ($event: any) => (_ctx.postAdd(item)),
                key: index,
                style: {"height":"50px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "text",
                    style: {"color":"var(--theme-secondary)"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "direction", "size"])
  ], 64))
}